function sanitizeForTracking(value: unknown, seen = new WeakSet()): unknown {
  if (
    value === null ||
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return value;
  }

  if (typeof window !== "undefined" && value instanceof Node) return undefined;
  if (typeof value === "function" || typeof value === "symbol")
    return undefined;
  if (value === undefined) return undefined;

  if (typeof value === "object") {
    if (seen.has(value)) return undefined;
    seen.add(value);

    if (Array.isArray(value)) {
      return value.map((item) => sanitizeForTracking(item, seen));
    }

    const plain: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value)) {
      const sanitized = sanitizeForTracking(val, seen);
      if (sanitized !== undefined) plain[key] = sanitized;
    }
    return plain;
  }

  return undefined;
}

export function trackInteraction(
  data: Record<string, any>,
  eventName = "link_click",
): void {
  if (typeof window === "undefined") return;

  const safeData = sanitizeForTracking(data) as Record<string, any>;

  // Google Analytics 4
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, safeData);
  }

  // Google Tag Manager
  if (Array.isArray((window as any).dataLayer)) {
    (window as any).dataLayer.push({
      event: eventName,
      ...safeData,
    });
  }

  // Development fallback
  if (process.env.NODE_ENV === "development") {
    console.debug("Track Event:", eventName, safeData);
  }
}
